import React, { useState, useEffect } from 'react';

export const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem('echocondria-cookie-consent');
      if (!consent) {
        setVisible(true);
      }
    } catch {
      setVisible(false);
    }
  }, []);

  const handleConsent = (accepted: boolean) => {
    try {
      localStorage.setItem('echocondria-cookie-consent', accepted ? 'accepted' : 'declined');
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <section
      className="cookie-consent shadow-lg"
      id="cookieConsentBanner"
      aria-label="Cookie preferences"
      aria-live="polite"
    >
      <div className="cookie-consent__content">
        <p className="cookie-consent__eyebrow mb-2">Cookies & Analytics</p>
        <p className="cookie-consent__text mb-0">
          This site uses cookies and local storage to save your visual theme preference and help us understand traffic.
        </p>
      </div>
      <div className="cookie-consent__actions">
        <button
          className="btn btn-outline-secondary btn-sm"
          type="button"
          onClick={() => handleConsent(false)}
        >
          Decline
        </button>
        <button
          className="btn btn-dark btn-sm"
          type="button"
          onClick={() => handleConsent(true)}
        >
          Allow
        </button>
      </div>
    </section>
  );
};
